module.exports = __webpack_public_path__ + "static/mower-a2ec974833d2d38b0a2bf14702e78d11.png";